import React, { Component } from 'react';
import './ChangeOrderQuoteDetailsModal.css';
import PropTypes from 'prop-types';
import FormModal from 'components/shared/modal/FormModal';
import DetailsInfoItem from 'components/shared/details/DetailsInfoItem';
import ImageUpload from 'components/shared/image-upload/ImageUpload';
import Number from 'components/shared/text/Number';
import Date from 'components/shared/text/Date';
import moment from 'moment';
import numeral from 'numeral';
import Input from 'components/shared/input/Input';
import Button from 'components/shared/button/Button';

class ChangeOrderQuoteDetailsModal extends Component {
  constructor(props) {
    super(props);

    const changeOrderQuote = props.changeOrderTask.change_order_quote;
    this.state = {
      readOnly: true,
      id: changeOrderQuote.id,
      estimate: changeOrderQuote.estimate || '',
      value: changeOrderQuote.value || '',
    };
  }

  static propTypes = {
    changeOrderTask: PropTypes.object.isRequired,
    task: PropTypes.object.isRequired,
    show: PropTypes.bool,
    workOrder: PropTypes.object.isRequired,
    onClose: PropTypes.func.isRequired,
    onSave: PropTypes.func.isRequired,
  };

  static defaultProps = {
    show: false,
  };

  handleEstimateChange = (estimate) => {
    this.setState({ estimate: estimate });
  };

  handleValueChange = (value) => {
    this.setState({ value: value });
  };

  handleClose = (event) => {
    event.preventDefault();
    this.props.onClose();
  };

  handleEdit = () => {
    this.setState({ readOnly: false });
  };

  handleCancel = () => {
    this.setState({ readOnly: true });
  };

  handleSave = () => {
    const { id, estimate, value } = this.state;
    const { onSave } = this.props;
    this.setState({ readOnly: true });
    onSave({ id, estimate, value });
  };

  render() {
    const { readOnly, estimate, value } = this.state;
    const changeOrderQuote = this.props.changeOrderTask.change_order_quote;
    let workOrderTitle = `WO #${this.props.workOrder.number}`;
    if (this.props.workOrder.name !== null) {
      workOrderTitle += `: ${this.props.workOrder.name}`;
    }
    return (
      <FormModal
        className="change-order-quote-details-modal"
        show={this.props.show}
        title={
          <span>
            <span className="title-task">
              Task # <Number value={this.props.task.number} format="00" />:{' '}
              {this.props.task.name} (CO #
              <Number value={this.props.changeOrderTask.number} format="00" />)
            </span>
            <span className="title-wo">({workOrderTitle})</span>
          </span>
        }
        onClose={this.handleClose}
      >
        <div className="task-wo-details-container">
          <div>
            <div>
              <DetailsInfoItem
                lines={[this.props.task.contractor_name]}
                title="CONTRACTOR"
              />
            </div>
          </div>
          <div>
            <div>
              <DetailsInfoItem
                lines={[
                  this.props.workOrder.building.location.street_address_1,
                  this.props.workOrder.building.location.city +
                    ', ' +
                    this.props.workOrder.building.location.state +
                    ' ' +
                    this.props.workOrder.building.location.zip,
                  this.props.workOrder.building.name !== '' &&
                  this.props.workOrder.building.name !== null
                    ? this.props.workOrder.building.name
                    : '',
                ]}
                title="BUILDING"
              />
            </div>
            <div>
              <DetailsInfoItem
                lines={this.props.workOrder.working_hours}
                title="AVAILABLE WORKING HOURS"
              />
            </div>
          </div>
          <div>
            <DetailsInfoItem
              lines={[this.props.changeOrderTask.description]}
              title="DESCRIPTION"
            />
          </div>
        </div>

        <div className="images-container">
          <ImageUpload
            images={this.props.changeOrderTask.images.map((img) => {
              return { url: img.image.url, preview: img.image.preview.url };
            })}
            readOnly={true}
          />
        </div>

        <div className="change-order-quote-details-container">
          {changeOrderQuote.start_date !== null && (
            <div className="quote start-date">
              <div>Start Date</div>
              <div>
                <Date value={changeOrderQuote.start_date} format="M/D/YYYY" />
              </div>
            </div>
          )}

          {changeOrderQuote.days_of_duration !== null && (
            <div className="quote">
              <div>Duration</div>
              <div>{`${numeral(changeOrderQuote.days_of_duration).format(
                '0.[0]'
              )} ${
                changeOrderQuote.days_of_duration > 1 ? 'days' : 'day'
              }`}</div>
            </div>
          )}

          {changeOrderQuote.material_lead_days !== null && (
            <div className="quote">
              <div>Material Lead Time</div>
              <div>{`${numeral(changeOrderQuote.material_lead_days).format(
                '0.[0]'
              )} ${
                changeOrderQuote.material_lead_days > 1 ? 'days' : 'day'
              }`}</div>
            </div>
          )}

          {this.props.changeOrderTask.completion_date !== null && (
            <div className="quote">
              <div>Task Completion Date</div>
              <div>
                <Date
                  value={this.props.changeOrderTask.completion_date}
                  format="M/D/YYYY"
                />
              </div>
            </div>
          )}

          {this.props.changeOrderTask.change_order_quote.end_date !== null &&
            this.props.changeOrderTask.completion_date !== null && (
              <div className="quote">
                <div>Contractor Completion Date</div>
                <div>
                  {this.getJobCompletionDiff() !== 0
                    ? `${
                        this.getJobCompletionDiff() > 0 ? '+' : ''
                      }${this.getJobCompletionDiff()} days from task completion date`
                    : 'Same as task completion date'}
                </div>
              </div>
            )}

          {readOnly && changeOrderQuote.estimate !== null && (
            <div className="quote cost">
              <div>Cost</div>
              <div>
                <Number value={changeOrderQuote.estimate} format="$ 0" />
              </div>
            </div>
          )}

          {readOnly && changeOrderQuote.estimate !== null && (
            <div className="quote cost">
              <div>Value</div>
              <div>
                <Number value={changeOrderQuote.value || ''} format="$ 0" />
              </div>
            </div>
          )}

          {!readOnly && (
            <div className="quote cost">
              <div>Cost</div>
              <div>
                <Input
                  id="quote-estimate"
                  onChange={this.handleEstimateChange}
                  value={estimate}
                  theme="normal"
                />
              </div>
            </div>
          )}

          {!readOnly && (
            <div className="quote cost">
              <div>Value</div>
              <div>
                <Input
                  id="quote-value"
                  onChange={this.handleValueChange}
                  value={value}
                  theme="normal"
                />
              </div>
            </div>
          )}

          {changeOrderQuote.estimate !== null && (
            <div className="quote cost">
              <div>Total</div>
              <div>
                <Number
                  value={numeral(estimate).value() + numeral(value).value()}
                  format="$ 0"
                />
              </div>
            </div>
          )}

          {changeOrderQuote.description !== null &&
            changeOrderQuote.description !== '' && (
              <div className="quote description">
                <div>Description</div>
                <div>{changeOrderQuote.description}</div>
              </div>
            )}

          <div className="quote status">
            <div>Status</div>
            <div>
              {changeOrderQuote.status.charAt(0).toUpperCase() +
                changeOrderQuote.status.slice(1)}
            </div>
          </div>

          {changeOrderQuote.submitted_at !== null && (
            <div className="quote submitted-date">
              <div />
              <div>
                Quoted Submitted on{' '}
                <Date value={changeOrderQuote.submitted_at} format="M/D/YYYY" />
              </div>
            </div>
          )}
        </div>

        <div className="button-container">
          {readOnly &&
            changeOrderQuote.status !== 'approved' &&
            changeOrderQuote.status !== 'acr' && (
              <Button
                className="button-orange"
                label="Edit"
                onClick={this.handleEdit}
              />
            )}

          {!readOnly && (
            <React.Fragment>
              <Button
                className="btn button button-white"
                label="Cancel"
                onClick={this.handleCancel}
              />
              <Button
                className="btn button button-orange"
                label="Save"
                onClick={this.handleSave}
              />
            </React.Fragment>
          )}
        </div>
      </FormModal>
    );
  }

  getJobCompletionDiff() {
    return moment(this.props.changeOrderTask.change_order_quote.end_date).diff(
      moment(this.props.changeOrderTask.completion_date),
      'days'
    );
  }
}

export default ChangeOrderQuoteDetailsModal;



// WEBPACK FOOTER //
// ./src/components/admin/work-orders/details/change-order-quotes/ChangeOrderQuoteDetailsModal.js